import { StyleSheet } from 'aphrodite';
import { titles } from '../../../../web/styles/colors';
import { BreakPoints, CssSelectors } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		boxSizing: 'border-box',
		width: '100%',
		height: '100%',
		paddingTop: 24,
	},
	infoHeaderContentBold: {
		marginTop: 4,
		marginBottom: 12,
		fontWeight: 600,
	},
	label: {
		fontSize: 14,
	},
	loadingRow: {
		height: 300,
	},
	viewOnlyModeBannerContent: {
		display: 'flex',
		fontSize: 14,
		padding: '20px 20px 20px 40px',
		gap: 8,
	},
	viewOnlyModeBannerContainer: {
		justifyContent: 'space-between',
		display: 'flex',
		background: '#FFEDF9',
		borderLeft: '3px solid #78DBFF',
		borderRadius: 3,
		boxSizing: 'border-box',
		color: titles,
		alignItems: 'flex-start',
		marginBottom: 16,
	},
	tableDataCell: {
		fontSize: 14,
	},
	button: {
		opacity: 1,
		transform: 'translate3d(0,0,0)',
		transition: 'opacity 0.2s, transform 0.2s',
		...CssSelectors.allChildren(
			{
				alignItems: 'center',
				background: 'none',
				borderRadius: 20,
				boxShadow: 'none',
				display: 'flex',
				marginRight: 12,
				padding: '8px 10px',
				transform: 'translate3d(0,0,0)',
				transition: 'background 0.2s, box-shadow 0.2s, transform 0.1s',
				[BreakPoints.forMaxWidth(1080)]: {
					alignItems: 'center',
					flexDirection: 'column',
					justifyContent: 'center',
					marginRight: 2,
				},
				':hover': {
					boxShadow: `0 1px 2px 1px  var(--lev-people-action-bar-button-hover-shadow)`,
				},
			},
			'span'
		),
		[BreakPoints.forMaxWidth(1080)]: {
			display: 'block',
			textAlign: 'center',
		},
		':active': {
			...CssSelectors.allChildren(
				{
					boxShadow: `0 0 2px 1px rgba(0,0,0, 0.1) !important`,
					transform: 'translate3d(0,0,0) !important',
				},
				'span'
			),
		},
		':hover': {
			...CssSelectors.allChildren(
				{
					background: 'white',
					transform: 'translate3d(0,-1px,0)',
				},
				'span'
			),
		},
	},
	buttonText: {
		marginLeft: 6,
		[BreakPoints.forMaxWidth(1080)]: {
			display: 'none',
		},
	},
	header: {
		paddingBottom: 16,
		alignItems: 'flex-end',
	},
	exportButton: {
		display: 'inline-flex',
	},
	actionsColumn: {
		width: 150,
		minWidth: 150,
		maxWidth: 150,
	},
	companyColumn: {
		width: 300,
		minWidth: 300,
		maxWidth: 300,
	},
	csmColumn: {
		width: 120,
		minWidth: 120,
		maxWidth: 120,
	},
	navLink: {
		textDecoration: 'none',
		':hover': {
			textDecoration: 'none',
		},
	},
});
